"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var base_1 = tslib_1.__importDefault(require("../base"));
var EmployeeTypeResource = /** @class */ (function (_super) {
    tslib_1.__extends(EmployeeTypeResource, _super);
    function EmployeeTypeResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EmployeeTypeResource.endpoint = '/employeetypes';
    EmployeeTypeResource.MODEL_NAME = 'employeetype';
    return EmployeeTypeResource;
}(base_1.default));
exports.default = EmployeeTypeResource;
//# sourceMappingURL=employeetype.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/resources/system/employeetype.js
// module id = DYbh
// module chunks = 0